var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudiodesc = function SvgAudiodesc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 15,
    fill: "none",
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--c-dark-blue2)",
    d: "M4.894 1.447A.999.999 0 1 0 3.106.554L.422 5.919A4 4 0 0 0 0 7.71V8a4 4 0 0 0 4 4h2.5v-.009a3.25 3.25 0 0 0 2.566-1.615 1 1 0 0 0-1.732-1A1.253 1.253 0 0 1 5 8.75a1.25 1.25 0 0 1 2.334-.625 1 1 0 0 0 1.732-1A3.28 3.28 0 0 0 7.24 5.654l2.525-.688a1 1 0 1 0-.525-1.931l-3.147.86 2.55-2.126A1 1 0 1 0 7.359.232L4.175 2.885zm10.212 13.107a1 1 0 1 0 1.788.893l2.684-5.365A4 4 0 0 0 20 8.294v-.29a4 4 0 0 0-4-4h-2.5v.01a3.25 3.25 0 0 0-2.566 1.615 1 1 0 0 0 1.731 1 1.25 1.25 0 1 1 0 1.25 1 1 0 0 0-1.731 1c.4.69 1.05 1.222 1.825 1.472l-2.525.687a1 1 0 1 0 .525 1.931l3.147-.86-2.55 2.126a1 1 0 0 0 1.281 1.537l3.185-2.653-.719 1.438z"
  })));
};
export default SvgAudiodesc;